import React, { useEffect, useState } from 'react';
import useIntersectionObserver from '../../../../../Hooks/useIntersectionObserver';

export default function WcPowerPage({ contentData }) {
  const { partNumber } = contentData;

  const ref = React.useRef(null);
  const onScreen = useIntersectionObserver(ref, { rootMargin: '0px 0px 600px 0px' });

  const [webCollageLoaded] = useState(() => {
    return typeof Webcollage !== 'undefined' && 'cpi' in Webcollage;
  });

  useEffect(() => {
    if (typeof Webcollage === 'undefined' || !onScreen) {
      return;
    }

    if (Webcollage.cpi !== partNumber) {
      partNumber && Webcollage.loadProductContent('dillards', partNumber, { 'power-page': { reload: true } });
    }
  }, [onScreen, partNumber]);

  return (
    <div id='wc-power-page' ref={ref}>
      {webCollageLoaded && (
        <div id='syndi_powerpage'>
          <syndigo-powerpage pageid={partNumber}></syndigo-powerpage>
        </div>
      )}
    </div>
  );
}
